import { PageHeader, Loading } from "wup-module1-base";
import { useNavigate } from "react-router-dom";
import {
  PageTitleConstants,
  ProcessStatusEnum,
  RoutePathConstants,
} from "../../Constants";
import { Card, Row, Col, Button } from "react-bootstrap";
import { useState, useContext } from "react";
import { updateUserCurrentStep } from "wup-module1-base";
import UserContext from "../../Contexts/UserContext";
import { ClientService } from "../../Services";

function StoreEdit() {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  function goNext() {
    navigate(`/${RoutePathConstants.CompletingBalanceSheetOfModuleSecond}`);
  }

  return (
    <>
      <PageHeader content={PageTitleConstants.StoreEdit} />
      <Card>
        <Card.Body>
          <Row className="mt-1">
            <Col md={12}>Treść strony</Col>
          </Row>
          <Row>
            <Col md={12}>
              <Button
                className="float-right px-3"
                type="button"
                variant="primary"
                disabled={isSubmitting}
                onClick={goNext}
              >
                {isSubmitting ? (
                  <Loading size="sm" className="px-3" variant="light" />
                ) : (
                  <>Dalej</>
                )}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
}

export default StoreEdit;
